import logo from './logo.svg'

export const theme = {
    color: {
      primary: "#f29400",
      primaryHover: "#b96600",
    },
    logoImage: logo,
    backend: "https://ama-digital.epaper-publishing-one.de/",
    directory: "/kiosk",
    header: {
      customer: "AMA Digital Networks",
      title: "Digitale Netzwerke für Innovatoren",
    },
    info: [
      {
      text: 'Impressum',
      link: 'https://www.ama-digital.de/kontakt'
    },
      {
      text: 'Datenschutz',
      link: 'https://www.ama-digital.de/datenschutz'
    },
  ],
  };